import { render, staticRenderFns } from "./Computed.vue?vue&type=template&id=1552c622&scoped=true&"
import script from "./Computed.vue?vue&type=script&lang=js&"
export * from "./Computed.vue?vue&type=script&lang=js&"
import style0 from "./Computed.vue?vue&type=style&index=0&id=1552c622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1552c622",
  null
  
)

export default component.exports